export const contactLensMaterialColumns = [
    {
        Header: 'ID',
        accessor: 'id',
        disableFilters: true,
        disableSortBy: true,
        width: 50,
    },
    {
        Header: 'Material Name',
        accessor: 'name',
        width: 200,
    },
    {
        Header: 'Water Content (%)',
        accessor: 'waterContent',
        width: 150,
        Cell: ({ value }) => value ? `${value}%` : '-',
    },
    {
        Header: 'Oxygen Permeability (Dk)',
        accessor: 'oxygenPermeability',
        width: 180,
        Cell: ({ value }) => value || '-',
    },
    {
        Header: 'Status',
        accessor: 'status',
        width: 100,
        Cell: ({ value }) => (
            <span style={{ 
                color: value === 'active' ? 'green' : 'gray',
                fontWeight: 'bold'
            }}>
                {value?.toUpperCase()}
            </span>
        ),
        filter: 'enum',
    },
    {
        Header: 'Notes',
        accessor: 'notes',
        width: 300,
        Cell: ({ value }) => value ? (
            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}>
                {value}
            </span>
        ) : '-',
    },
];
